import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_TASKLIST,
  DELETE_TASKLIST,
  UPDATE_TASKLIST,
  ADD_NEW_TASKLIST,
} from "./actionType";

import {
  getTaskListSuccess,
  getTaskListFail,
  deleteTaskListSuccess,
  deleteTaskListFail,
  updateTaskListSuccess,
  updateTaskListFail,
  addTaskListSuccess,
  addTaskListFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveTaskListApi,
  getTaskListApi,
  updateTaskListApi,
  deleteTaskListApi,
  addNewTaskListApi
} from "../../helpers/backend_helper";

function* getTaskList({ payload: taskList }) {
  try {
    const response = yield call(getTaskListApi, taskList);
    yield put(getTaskListSuccess(GET_TASKLIST, response.data));
  } catch (error) {
    yield put(getTaskListFail(GET_TASKLIST, error));
  }
}

function* onUpdateTaskList({ payload: taskList }) {
  try {
    if (taskList.setApprove) {
      const response = yield call(approveTaskListApi, taskList);
      yield put(updateTaskListSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateTaskListApi, taskList);
      yield put(updateTaskListSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateTaskListFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteTaskList({ payload: taskList }) {
  try {
    const response = yield call(deleteTaskListApi, taskList);
    yield put(deleteTaskListSuccess({ taskList, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteTaskListFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewTaskList({ payload: taskList }) {
  try {
    const response = yield call(addNewTaskListApi, taskList);
    yield put(addTaskListSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addTaskListFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetTaskList() {
  yield takeEvery(GET_TASKLIST, getTaskList);
}

export function* watchUpdateTaskList() {
  yield takeEvery(UPDATE_TASKLIST, onUpdateTaskList);
}

export function* watchDeleteTaskList() {
  yield takeEvery(DELETE_TASKLIST, onDeleteTaskList);
}

export function* watchAddNewTaskList() {
  yield takeEvery(ADD_NEW_TASKLIST, onAddNewTaskList);
}

function* taskListSaga() {
  yield all([
    fork(watchGetTaskList),
    fork(watchDeleteTaskList),
    fork(watchUpdateTaskList),
    fork(watchAddNewTaskList)
  ]);
}

export default taskListSaga;
